import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=65c00669&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=65c00669&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c00669",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c00669')) {
      api.createRecord('65c00669', component.options)
    } else {
      api.reload('65c00669', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=65c00669&scoped=true&", function () {
      api.rerender('65c00669', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23LixZY8t6TPM/JS/comp/Voucher.vue"
export default component.exports